import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const ExplorerIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.5 17.2119L13.7472 14.4591M1.5 9.33691C1.5 5.40189 4.68997 2.21191 8.625 2.21191C12.56 2.21191 15.75 5.40189 15.75 9.33691C15.75 13.2719 12.56 16.4619 8.625 16.4619C4.68997 16.4619 1.5 13.2719 1.5 9.33691Z"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
